import WsEmitter, { wsEvents } from '../api/ws.emitter';
import { wsConfig } from '../config/ws.config';
import { RootStore } from './Root.store';
import { IMessage } from '../api/ws.emitter';

interface IGroupEvent {
    groupId?: string;
}

interface IDeviceEvent {
    imei?: string;
}

interface ISubuserEvent {
    login?: string;
}

interface IEvent extends IGroupEvent, IDeviceEvent, ISubuserEvent {}

interface ICommand {
    cmd?: string;
    type?: string;
    content?: IEvent;
}

enum userTypes {}

enum groupTypes {
    group_create = 'group_create',
    group_delete = 'group_delete',
    group_change = 'group_change',
    group_changedesc = 'group_changedesc',
}

enum devicesTypes {
    group_adddevice = 'group_adddevice',
    device_add = 'device_add',
    device_remove = 'device_remove',
    device_change = 'device_change',
}

enum telemetryTypes {
    telemetry = 'telemetry',
}

enum subusersTypes {
    subuser_create = 'subuser_create',
    subuser_delete = 'subuser_delete',
    subuser_adddevice = 'subuser_adddevice',
    subuser_removedevice = 'subuser_removedevice',
}

export default class WsMiddleware {
    wsMessages = {
        groups: 'groups',
        devices: 'devices',
        user: 'user',
        telemetry: 'telemetry',
        subusers: 'subusers',
    };
    ws: WsEmitter;

    constructor(private rootStore: RootStore) {
        const pingMessage = { cmd: 'ping' };
        this.ws = new WsEmitter(wsConfig, pingMessage);
        this.ws.on(wsEvents.connect, () => this._handleConnect.call(this));
        this.ws.on(wsEvents.disconnect, () =>
            this._handleDisconnect.call(this),
        );
        this.ws.on(wsEvents.message, (message: IMessage | string) =>
            this._handleWsMessage.call(this, message),
        );
        if (
            this.rootStore.user.token &&
            this.rootStore.user.userLogin !== 'demo'
        )
            this.ws.connect();
    }

    connect() {
        this.ws.connect();
    }

    close() {
        this.ws.close();
    }

    reconnect() {
        this.ws.reconnect();
    }

    _auth() {
        const token = this.rootStore.user.token;
        if (token) {
            const message = {
                cmd: 'auth_req',
                token,
            };
            this.ws.sendMessage(message);
        }
    }

    _handleConnect() {
        this._auth();
    }

    _handleDisconnect() {}

    _handleWsMessage(message?: IMessage | string) {
        if (!message || typeof message !== 'object') return;
        const { data } = message;
        if (!data) return;
        let parsedData: ICommand;
        try {
            parsedData = JSON.parse(data);
        } catch (e) {
            return;
        }
        const { cmd, type, content } = parsedData;
        if (cmd === 'notification') this._switchType(type, content);
    }

    _switchType(type?: string, content?: IEvent) {
        if (!type) return;
        if (type in userTypes) this._handleUser();
        if (type in groupTypes) this._handleGroups(content);
        if (type in devicesTypes) this._handleDevices(content);
        if (type in telemetryTypes) this._handleTelemetry(content);
        if (type in subusersTypes) this._handleSubusers(content);
    }

    _handleGroups(content?: IGroupEvent | string) {
        this.rootStore.groups.getUserGroups();
    }

    _handleDevices(content?: IDeviceEvent | string) {
        let imei: string | void;
        if (content && typeof content === 'object') {
            imei = content.imei;
        }
        if (imei) {
            const [device] = this.rootStore.devices.deviceList.filter(
                (item) => item.imei === imei,
            );
            if (device && device.groupId) {
                this.rootStore.devices.getGroupDevices(device.groupId);
            } else this.rootStore.devices.getGroupsDevices();
        }
        this.rootStore.devices.getGroupsDevices();
    }

    _handleUser() {
        this.rootStore.user.getSettings();
    }

    _handleTelemetry(content?: IDeviceEvent | string) {
        let imei: string | void;
        if (content && typeof content === 'object') {
            imei = content.imei;
        }
        if (imei) {
            const [device] = this.rootStore.devices.deviceList.filter(
                (device) => device.imei === imei,
            );
            if (device && device.groupId) {
                this.rootStore.devices.getGroupDevices(device.groupId);
            }
        }
    }

    _handleSubusers(content?: ISubuserEvent | string) {
        this.rootStore.subusers.getSubusers();
    }
}
